export default __webpack_public_path__ + "static/media/python_logo.78af7652.webp";